import React from "react";

type VideoType = {
    videoId: string;
    title?: string;
    poster?: string;
};

const YouTubeEmbed = ({
                          videoId,
                          title = "YouTube video",
                      }: VideoType) => {
    return (
        <div className="relative w-full pb-[56.25%]">
            <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title={title}
                loading="lazy"
                className="absolute inset-0 w-full h-full border-0"
                allow="accelerometer; encrypted-media; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};

export default YouTubeEmbed;
